<template>
  <div class="exploration-table">
    <div class="table-top-content">
      <div class="d-flex">
        <p class="recent-activity-wrap">Fluids Characterization Data</p>
        <div class="applied-filters" v-if="filterDetails">
          <span v-if="filterDetails && filterDetails.fluidSampleID && filterDetails.fluidSampleID.length > 0">Sample ID:
            {{
              filterDetails.fluidSampleID.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.asset && filterDetails.asset.length > 0">Asset: {{
            filterDetails.asset.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.field && filterDetails.field.length > 0">Field: {{
            filterDetails.field.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.well && filterDetails.well.length > 0">Well: {{
            filterDetails.well.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.reservoir && filterDetails.reservoir.length > 0">Reservoir: {{
            filterDetails.reservoir.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.fluidType && filterDetails.fluidType.length > 0">Fluid Type: {{
            filterDetails.fluidType.join(', ') }}</span>
            <span v-if="filterDetails && filterDetails.sampleType && filterDetails.sampleType.length > 0">Sample Type: {{
            filterDetails.sampleType.join(', ') }}</span>
            <span v-if="filterDetails && filterDetails.fluidClassification && filterDetails.fluidClassification.length > 0">Fluid Classification: {{
            filterDetails.fluidClassification.join(', ') }}</span>
          <span v-if="filterDetails && filterDetails.selectedTests && filterDetails.selectedTests.length > 0">Test: {{
            filterDetails.selectedTests.join(', ') }}</span>
          <div class="reset-icon-div" v-if="filterDetails && !areFiltersEmpty" @click="resetFilters">
            <v-img :src="reset_icon" alt="reset-icon"></v-img>
            <span>Reset</span>
          </div>
        </div>
      </div>
      <div v-if="filterData?.samples?.length > 0">
        <div v-if="loadingCsv" class="pdf-btn">
          <div>Exporting..</div>
        </div>
        <div v-else class="pdf-btn">
              <img :src="documentDownload"  @click="downloadTableCSV" alt="pdf icon" />
        </div>
      </div>
    </div>
    <v-data-table-server
      :page="page"
      :items-per-page="itemsPerPage"
      @update:page="emitPaginationPage"
      @update:items-per-page="emitPaginationItemsPerPage"
      :headers="headers"
      :items="serverItems"
      :items-per-page-options="pageOptions"
      :items-length="totalItems"
      :loading="loading"
      item-value="name"
      :height="tableHeight"
    >
      <template v-slot:loader>
        <v-skeleton-loader type="table-row-divider" :loading="loading" :types="{
          'table-row-divider': {
            height: '400px',
            rows: 5
          }
        }" style="background-color: #ffffff;">
        </v-skeleton-loader>
      </template>
      <template v-slot:headers>
        <tr>
          <th v-for="header in headers" :key="header.value" class="text-left search-dropdown-menu"
            :style="{ backgroundColor: searchDropdowns[header.key] ? 'black !important' : 'transparent' }">

            <v-menu v-if="header.key != 'report' && header.key != 'exportPVTSim'" v-model="searchDropdowns[header.key]" :close-on-content-click="false"
              v-model:return-value="selectedLocations[header.key]" transition="scale-transition">
              <template v-slot:activator="{ props }">
                <span v-bind="props" :id="`menu-activator-${header.key}`"></span>
              </template>
              <v-list style="min-width: 182px;
                max-width: 200px;
                border-radius: 8px !important;
                height: 244px !important;
                padding:8px;
                max-height: 244px;
                overflow-y: auto;
                position: absolute;
                top: 3.25em;
                left: -4.25em;
                transform: translateY(-1.25em);
              ">
                <!-- Search Field -->
                <v-text-field variant="solo" class="search-table" v-model="searchQuery[header.key]"
                  :label="`Search ${header.title}`" single-line hide-details>
                  <template v-slot:prepend>
                    <v-img :src="magnify_black" class="ml-2" width="20" height="20"></v-img>
                  </template>
                </v-text-field>


                <!-- Skeleton Loader -->
                <v-skeleton-loader v-if="searchLoading" class="pa-2" />

                <!-- No Data Found -->
                <v-list-item v-else-if="filteredItems(header.key).length === 0" disabled>
                  <v-list-item-title style="font-size: 13.50px;">No data found</v-list-item-title>
                </v-list-item>

                <v-list-item class="list-items"
                  style="margin: 0 !important; padding: 0 10px !important; height: 34px !important;"
                  v-for="location in filteredItems(header.key)" :key="location.name">
                  <!-- <v-checkbox style="height: 34px !important;" :label="location.name"
                    :model-value="location.isSelected"
                    @change="toggleSelection(header.key, location.name, location.isSelected)" @click.stop
                    hide-details /> -->
                  <div class="data-list-content">
                    <input variant="solo" class="custom-field" type="checkbox" :model-value="location.isSelected"
                      :checked="location.isSelected"
                      @change="toggleSelection(header.key, location.name, location.isSelected, location.key)" @click.stop />
                    <span>{{ location.name }}</span>
                  </div>
                </v-list-item>
              </v-list>
            </v-menu>

            <div class="d-flex align-center justify-space-between">
              <div class="sort-icon-title d-flex align-center" style="gap: 10px">
                <div class="sort-icons" v-if="header.key != 'report' && header.key != 'exportPVTSim'">
                  <!-- Ascending Sort -->
                  <div class="img-div">
                    <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sort(header.title, 'asc')" />
                  </div>
                  <!-- Descending Sort -->
                  <div class="img-div">
                    <img :src="sort_down" alt="sort-down" class="cursor-pointer" @click="sort(header.title, 'desc')" />
                  </div>
                </div>
                {{ header.title }}
              </div>
              <div class="close-icon" v-if="searchDropdowns[header.key]" @click="searchDropdowns[header.key] = false && header.key != 'report' && header.key != 'exportPVTSim'">
                <v-img :src="close_icon" alt="close-icon"></v-img>
              </div>
              <div v-else-if="header.key != 'report' && header.key != 'exportPVTSim'" class="search-icon" @click="showSearchDropdown(header.key)"
                :id="`menu-activator-${header.key}`">
                <v-img :src="magnify" alt="reset-icon"></v-img>
              </div>
            </div>
          </th>
        </tr>
      </template>
      <template v-slot:item="{ item }">
        <tr>
          <td>
            <template v-if="item.fluidSampleID">
              <span class="clickable-cell no-bg" @click="navigateToSampleInformation(item.ID)">{{
                item.fluidSampleID
              }}</span>
            </template>
          </td>
          <td>
            <template v-if="item.location?.asset">
              <span class="clickable-cell no-bg" @click="navigateToAsset(item.location.asset, item.ID)">{{
                item.location.asset
              }}</span>
            </template>
          </td>
          <td>
            <template v-if="item.location?.field">
              <span class="clickable-cell no-bg"
                @click="navigateToField(item.location.asset, item.location.field, item.ID)">{{ item.location.field
                }}</span>
            </template>
          </td>
          <td>
            <template v-if="item.location?.well">
              <span class="clickable-cell no-bg"
                @click="navigateToWell(item.location.asset, item.location.field, item.location.well, item.ID)">{{
                  item.location.well }}</span>
            </template>
          </td>
          <td>{{ item.location?.reservoir || '' }}</td>
          <td>{{ item.fluidType || "" }}</td>
          <td>
            <div class="test-links">
              <span class="clickable-cell mr-0" @click="navigateToSampleValidation(item.location.asset, item.location.field, item.location.well, item.ID)">
                Sample Validation
              </span>
              <template v-if="item.IsTestAvailable">
                <span v-if="item.compositiontests?.length" class="clickable-cell mr-0"
                  @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'compositiontests', test.ID, item.ID)" v-for="(test, index) in item.compositiontests" :key="index">
                  <template v-if="test.contaminationType || test.recombinationType">
                    Composition (
                    <template v-if="test.contaminationType">
                        {{ test.contaminationType }}
                    </template>
                    <template v-else-if="test.recombinationType">
                        {{ test.recombinationType }}
                    </template>
                    <template v-if="index < item.compositiontests.length - 1">
                        /
                    </template>
                    )
                  </template>
                  <template v-else>
                    Composition
                  </template>
                </span>
                <template v-if="item.ccetests?.length">
                  <span v-for="(test, index) in item.ccetests" :key="index" class="clickable-cell mr-0"
                    @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'ccetest', test.ID, item.ID)">
                    {{ test.name || 'CCE' }}{{ item.ccetests.length > 1 ? ` (${test.testTemperature ? `${test.testTemperature} ${test.testTemperature_UOM}` : test.testNumber})` : '' }}
                  </span>
                </template>
                <template v-if="item.dltests?.length">
                  <span v-for="(test, index) in item.dltests" :key="index" class="clickable-cell mr-0"
                    @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'dltest', test.ID, item.ID)">
                    {{ test.name || 'DL' }}{{ item.dltests.length > 1 ? ` (${test.testTemperature ? `${test.testTemperature} ${test.testTemperature_UOM}` : test.testNumber})` : '' }}
                  </span>
                </template>
                <template v-if="item.cvdtests?.length">
                  <span v-for="(test, index) in item.cvdtests" :key="index" class="clickable-cell mr-0"
                    @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'cvdtest', test.ID, item.ID)">
                    {{ test.name || 'CVD' }}{{ item.cvdtests.length > 1 ? ` (${test.testTemperature ? `${test.testTemperature} ${test.testTemperature_UOM}` : test.testNumber})` : '' }}
                  </span>
                </template>
                <template v-if="item.separatortests?.length">
                  <span v-for="(test, index) in item.separatortests" :key="index" class="clickable-cell mr-0"
                    @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'separatortest', test.ID, item.ID)">
                    {{ test.name || 'Separator Test' }}{{ item.separatortests.length > 1 ? ` (${test.testTemperature ? `${test.testTemperature} ${test.testTemperature_UOM}` : test.testNumber})` : '' }}
                  </span>
                </template>
                <template v-if="item.viscositytests?.length">
                  <span v-for="(test, index) in item.viscositytests" :key="index" class="clickable-cell mr-0"
                    @click="navigateToTest(item.location.asset, item.location.field, item.location.well, 'viscositytest', test.ID, item.ID)">
                    {{ test.name || 'Viscosity' }}{{ item.viscositytests.length > 1 ? ` (${test.testTemperature ? `${test.testTemperature} ${test.testTemperature_UOM}` : test.testNumber})` : '' }}
                  </span>
                </template>
              </template>
            </div>
          </td>
          <td class="flex justify-center items-center">
            <img v-if="item.source && item.source != 'Synthetic Data'" 
                 @click="goToPdf(item.ID, !item.source.includes('.') ? 'pdf' :
                   item.source.toLowerCase().endsWith('.pdf') ? 'pdf' : 
                   item.source.toLowerCase().endsWith('.xlsm') ? 'xlsm' :
                   item.source.toLowerCase().endsWith('.xlsx') ? 'xlsx' :
                   item.source.toLowerCase().endsWith('.xls') ? 'xls' : 'pdf')" 
                 :src="!item.source.includes('.') ? pdfIcon :
                   item.source.toLowerCase().endsWith('.pdf') ? pdfIcon : 
                   item.source.toLowerCase().endsWith('.xlsm') ? excelIcon :
                   item.source.toLowerCase().endsWith('.xlsx') ? excelIcon :
                   item.source.toLowerCase().endsWith('.xls') ? excelIcon : pdfIcon"
                 :alt="!item.source.includes('.') ? 'PDF' :
                   item.source.toLowerCase().endsWith('.pdf') ? 'PDF' : 'Excel'"
                 style="width: 20px; height: 20px; margin-left: 1.5rem; cursor: pointer;" />
          </td>
          <td class="flex justify-center items-center">
            <img v-if="item.ID && item.fluidSampleID"
                 @click="exportToPVTSim(item.ID, item.fluidSampleID)"
                 :src="excelIcon"
                 alt="Export to PVTSim"
                 style="width: 20px; height: 20px; margin-left: 1.5rem; cursor: pointer;" />
          </td>

        </tr>
      </template>
      <template v-slot:no-data>
        <div class="d-flex justify-center align-center pa-4">
          No data available
        </div>
      </template>
      <template #bottom></template>
    </v-data-table-server>
  </div>
</template>

<script>
import api from "../../axiosInterceptor";
import axios from "axios";
import { getTenantPrefix } from "../../utils/tenant"
import { blobFromSampleReportResponse } from "../../utils/sampleReportDownload";
import store from "../../store"

export default {
  name: "TableData",
  props: {
    page: { type: Number, default: 1 },
    itemsPerPage: { type: Number, default: 20 },
    filterData: {
      type: Object,
      default: () => ({})
    },
    filterDetails: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showFilter: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      sort_up: require("../../assets/Svg/Table/up.svg"),
      sort_down: require("../../assets/Svg/Table/down.svg"),
      reset_icon: require("../../assets/Images/reset.png"),
      magnify: require("../../assets/Images/MagnifyingGlass.png"),
      magnify_black: require("../../assets/Images/magnify-black.png"),
      close_icon: require("../../assets/Images/close-circle.png"),
      documentDownload: require("../../assets/Images/csv.svg"),
      pdfIcon: require("../../assets/Svg/pdfIcon.svg"),
      excelIcon: require("../../assets/Svg/excelIcon.svg"),
      headers: [
        {
          title: 'Sample ID',
          sortable: false,
          key: 'fluidSampleID',
        },
        {
          title: 'Assets',
          sortable: false,
          key: 'assets',
        },
        {
          title: 'Fields',
          key: 'fields',
          sortable: false,
        },
        {
          title: 'Wells',
          key: 'wells',
          sortable: false,
        },
        { title: 'Reservoir', key: 'reservoirs', sortable: false, },
        { title: 'Fluid Type', key: 'fluidType', sortable: false, },
        { title: 'Tests', key: 'tests', sortable: false, },
        { title: 'Source Reports', key: 'report', sortable: false, },
        { title: 'Export to PVTSim', key: 'exportPVTSim', sortable: false, },
      ],
      serverItems: [],
      loading: false,
      totalItems: 0,
      pageOptions: [20, 50, 100, 200, 300, 400, 500],
      searchDropdowns: {
        assets: false,
        fields: false,
        wells: false,
        reservoirs: false,
      },
      selectedLocations: {
        assets: [],
        fields: [],
        wells: [],
        reservoirs: [],
        fluidTypes: [],
        tests: [],
        fluidSampleID: []
      },
      searchDropdownItems: {
        assets: [],
        fields: [],
        wells: [],
        reservoirs: [],
        fluidType: [],
        tests: [],
        fluidSampleID: []
      },
      searchQuery: [], // New property for search input
      searchLoading: false,
      samplesCSV: [],
      loadingCsv: false
    }
  },
  computed: {
    areFiltersEmpty() {
      const isSelectedLocationsEmpty = Object.values(this.selectedLocations).every(
        (locations) => locations.length === 0
      );

      if (isSelectedLocationsEmpty) {
        if (!this.filterDetails || typeof this.filterDetails !== "object") {
          return true;
        }
      }
      return Object.values(this.filterDetails).every(
        (value) => value === undefined || (Array.isArray(value) && value.length === 0)
      );
    },
    filteredItems() {
      return (key) => {
        const items = this.searchDropdownItems[key] || [];
        const searchQuery = this.searchQuery[key]?.toLowerCase() || '';
        const selectedLocations = this.selectedLocations[key] || [];

        const matchingItems = items.filter((item) =>
          item.name?.toLowerCase().includes(searchQuery)
        );
        const itemsToShow = searchQuery
          ? matchingItems // Show only matching items when there's a search query
          : items; // Show all items when no search query exists

        
        const result = itemsToShow.map((item) => {
          const isCompositionSelected = item.name === 'Composition' && selectedLocations.includes('compositiontests');
          return {
            ...item,
            isSelected: item.isSelected || selectedLocations.includes(item.name) || isCompositionSelected,
          };
        });

        return result;

      };
    },

    tableHeight() {
      return 'auto';
    },
  },
  methods: {
    resetFilters() {
      localStorage.removeItem('lastFilterId'); // Remove lastFilterId from local storage
      this.$emit('resetFiltersEmitted');
    },
    toggleSelection(column, locationName, isSelected, testKey) {
      let target = locationName;
      if (testKey === 'compositiontests') {
        target = testKey;
      }

      const selectedLocations = this.selectedLocations[column] || [];

      this.searchDropdownItems[column].forEach(item => {
        if (item.isSelected && !selectedLocations.includes(item.name)) {
          selectedLocations.push(item.name);
        }
      });

      const index = selectedLocations.indexOf(target);

      if (isSelected) {
        selectedLocations.splice(index, 1);
      } else {
        selectedLocations.push(target);
      }

      this.selectedLocations[column] = selectedLocations;

      this.searchDropdownItems[column].forEach(item => {
        if (item.name === target) {
          item.isSelected = !isSelected;  // Toggle the selection state
        }
      });

      const columnMapping = {
        assets: "asset",
        fields: "field",
        wells: "well",
        reservoirs: "reservoir",
        fluidType: "fluidType",
        tests: "selectedTests",
        fluidSampleID: "fluidSampleID",
      };

      const filterKey = columnMapping[column];
      if (!filterKey) {
        return;
      }

      if (this.filterDetails) {
        if (isSelected) {
          if (this.filterDetails[filterKey]) {
            const filterIndex = this.filterDetails[filterKey].indexOf(target);
            if (filterIndex !== -1) {
              this.filterDetails[filterKey].splice(filterIndex, 1);
            }
          }
        } else {
          if (!this.filterDetails[filterKey]) {
            this.filterDetails[filterKey] = [];
          }

          if (!this.filterDetails[filterKey].includes(target)) {
            this.filterDetails[filterKey].push(target);
          }
        }

      }
      this.selectLocation();
    },
    showSearchDropdown(column) {
      this.searchDropdowns[column] = !this.searchDropdowns[column];
      if (this.searchDropdowns[column]) {
        this.fetchLocations(column);
      }
    },
    emitPaginationPage(page) {
      this.$emit('update:pagination', {
        page: Number(page),
        itemsPerPage: Number(this.itemsPerPage),
      });
      this.loadItems();
      localStorage.setItem('itemsPerPage', String(this.itemsPerPage));
    },
    emitPaginationItemsPerPage(itemsPerPage) {
      const n = Number(itemsPerPage);
      this.$emit('update:pagination', { page: 1, itemsPerPage: n });
      this.loadItems();
      localStorage.setItem('itemsPerPage', String(n));
    },

    loadItems() {
      this.loading = this.isLoading;
      if (this.filterData && this.filterData.samples) {
        const samples = this.filterData.samples;
        const pagination = this.filterData.pagination;

        this.serverItems = samples;
        this.totalItems = pagination.TotalRecords;
        this.loading = false;
      }else{
        this.serverItems = [];
        this.totalItems = 0;
        this.loading = false;
      }
    },

    navigateToAsset(asset, sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && asset) {
        const encodedAsset = encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-");
        const url = `/${tenant}/assets/${encodedAsset}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },

    navigateToField(asset, field, sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && asset && field) {
        const encodedAsset = encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedField = encodeURIComponent(field).replace(/'/g, "%27").replace(/ /g, "-");
        const url = `/${tenant}/assets/${encodedAsset}/${encodedField}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },

    navigateToWell(asset, field, well, sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && asset && field && well) {
        const encodedAsset = encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedField = encodeURIComponent(field).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedWell = encodeURIComponent(well).replace(/'/g, "%27").replace(/ /g, "-");
        const url = `/${tenant}/assets/${encodedAsset}/${encodedField}/${encodedWell}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },

    navigateToSamples(asset, field, well, sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && asset && field && well) {
        const encodedAsset = encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedField = encodeURIComponent(field).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedWell = encodeURIComponent(well).replace(/'/g, "%27").replace(/ /g, "-");
        const url = `/${tenant}/assets/${encodedAsset}/${encodedField}/${encodedWell}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },

    navigateToTest(asset, field, well, testType, testId, sampleId) {
      const tenant = getTenantPrefix();
      const encodeSeg = (v) => (v ? encodeURIComponent(v).replace(/'/g, "%27").replace(/ /g, "-") : "");
      const pathWithOptionalSample = (encodedAsset, encodedField, encodedWell) => {
        const base = `/${tenant}/assets/${encodedAsset}/${encodedField}/${encodedWell}`;
        return sampleId ? `${base}/${encodeSeg(sampleId)}/${testType}/${testId}` : `${base}/${testType}/${testId}`;
      };
      if (tenant && asset && field && well && testType && testId) {
        const encodedAsset = encodeSeg(asset);
        const encodedField = encodeSeg(field);
        const encodedWell = encodeSeg(well);
        const url = pathWithOptionalSample(encodedAsset, encodedField, encodedWell);
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      } else {
        const notAvailable = "NotAvail";
        const encodedAsset = asset ? encodeSeg(asset) : notAvailable;
        const encodedField = field ? encodeSeg(field) : notAvailable;
        const encodedWell = well ? encodeSeg(well) : notAvailable;
        const url = pathWithOptionalSample(encodedAsset, encodedField, encodedWell);
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },
    navigateToSampleValidation(asset, field, well, sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && asset && field && well && sampleId) {
        const encodedAsset = encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedField = encodeURIComponent(field).replace(/'/g, "%27").replace(/ /g, "-");
        const encodedWell = encodeURIComponent(well).replace(/'/g, "%27").replace(/ /g, "-");
        const url = `/${tenant}/assets/${encodedAsset}/${encodedField}/${encodedWell}/samplevalidation/${sampleId}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      } else {
        const notAvailable = "NotAvail";
        const encodedAsset = asset ? encodeURIComponent(asset).replace(/'/g, "%27").replace(/ /g, "-") : notAvailable;
        const encodedField = field ? encodeURIComponent(field).replace(/'/g, "%27").replace(/ /g, "-") : notAvailable;
        const encodedWell = well ? encodeURIComponent(well).replace(/'/g, "%27").replace(/ /g, "-") : notAvailable;
        const url = `/${tenant}/assets/${encodedAsset}/${encodedField}/${encodedWell}/samplevalidation/${sampleId}`;
        this.$router.push(url);
        localStorage.setItem("lastView", url);
      }
    },
    navigateToSampleInformation(sampleId) {
      const tenant = getTenantPrefix();
      if (tenant && sampleId) {
        const currentItem = this.serverItems.find(item => item.ID === sampleId);
        if (currentItem && currentItem.location) {
          const asset = currentItem.location.asset ? encodeURIComponent(currentItem.location.asset).replace(/'/g, "%27").replace(/ /g, "-") : "NotAvail";
          const field = currentItem.location.field ? encodeURIComponent(currentItem.location.field).replace(/'/g, "%27").replace(/ /g, "-") : "NotAvail";
          const well = currentItem.location.well ? encodeURIComponent(currentItem.location.well).replace(/'/g, "%27").replace(/ /g, "-") : "NotAvail";
          const url = `/${tenant}/assets/${asset}/${field}/${well}/sampleinformation/${sampleId}`;
          this.$router.push(url);
          localStorage.setItem("lastView", url);
        } else {
          const url = `/${tenant}/assets/NotAvail/NotAvail/NotAvail/sampleinformation/${sampleId}`;
          this.$router.push(url);
          localStorage.setItem("lastView", url);
        }
      }
    },
    showSearchDropdown(column) {
      this.searchDropdowns[column] = !this.searchDropdowns[column];
      if (column === 'assets') {
        this.fetchLocations('assets');
      } else if (column === 'fields') {
        this.fetchLocations('fields');
      } else if (column === 'wells') {
        this.fetchLocations('wells');
      } else if (column === 'reservoirs') {
        this.fetchLocations('reservoirs');
      } else if (column === 'fluidType') {
        this.fetchLocations('fluidType');
      } else if (column === 'tests') {
        this.fetchLocations('tests');
      } else if (column === 'fluidSampleID') {
        this.fetchLocations('fluidSampleID');
      }
    },
    async fetchLocations(columnName) {
      this.searchLoading = true;
      var columns = "";
      const query = {
        asset: this.selectedLocations.assets ? JSON.stringify(this.selectedLocations.assets) : [], // Convert to JSON string
        field: this.selectedLocations.fields ? JSON.stringify(this.selectedLocations.fields) : [], // Convert to JSON string
        well: this.selectedLocations.wells ? JSON.stringify(this.selectedLocations.wells) : [],   // Convert to JSON string
        reservoir: this.selectedLocations.reservoirs ? JSON.stringify(this.selectedLocations.reservoirs) : [], // Convert to JSON string
        fluidSampleID: this.selectedLocations.fluidSampleID ? JSON.stringify(this.selectedLocations.fluidSampleID) : [], // Convert to JSON string
      };

      if (columnName === "assets") {
        columns = "asset";
        query.asset = "[]"; // Reset asset filters
        query.field = "[]";
        query.well = "[]";
        query.reservoir = "[]";
        query.fluidSampleID = "[]";
      } else if (columnName === "fields") {
        columns = "field";
        query.field = "[]"; // Reset field filters
        query.well = "[]";
        query.reservoir = "[]";
        query.fluidSampleID = "[]";
      } else if (columnName === "reservoirs") {
        columns = "reservoir";
        query.reservoir = "[]"; // Reset reservoir filters
        query.fluidSampleID = "[]";
      } else if (columnName === "wells") {
        columns = "well";
        query.well = "[]"; // Reset well filters
        query.fluidSampleID = "[]";
      } else if (columnName === "fluidType") {
        columns = "fluidType";
        query.fluidSampleID = "[]"; // Reset sampleKind filters
      } else if (columnName === "tests") {
        columns = "tests";
        query.fluidSampleID = "[]"; // Reset tests filters
      } else if (columnName === "fluidSampleID") {
        columns = "fluidSampleID";
        query.fluidSampleID = "[]"; // Reset fluidSampleID filters
      }

      try {
        let response = "";
        let locations = "";
        if (columnName === "fluidType") {
          columns = "fluidType";
          response = await api.get(`/public/api/summary/${columnName}`, { params: query });
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            locations = response.data.data.columnSummary.filter((fluidType) => fluidType.name) || [];
            this.searchDropdownItems[columnName] = locations.sort((a, b) => a.name ? a.name.localeCompare(b.name) : 0);
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Unexpected status code for fluidType");
          }
        } else if (columnName === "tests") {
          response = await api.get(`/public/api/list/${columnName}`);
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            locations = response.data.data.list || [];
            this.searchDropdownItems[columnName] = locations;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Unexpected status code for tests");
          }
        } else if (columnName === "fluidSampleID") {
          response = await api.get(`/public/api/unique-values/${columnName}`);
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            locations = response.data.data.columnUniqueValues.Values.map(value => ({ name: value })) || [];
            this.searchDropdownItems[columnName] = locations;
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Unexpected status code for fluidSampleID");
          }
        } else {
          response = await api.get(`/public/api/locations/${columnName}`, { params: query });
          if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
            locations = response.data.data.locations || [];
            this.searchDropdownItems[columnName] = locations.sort((a, b) => a.name.localeCompare(b.name));
          }
          else if (response && response.data && response.data.message) {
            console.error(response.data.message);
          }
          else {
            console.error("Unexpected status code for locations");
          }
        }
        if (this.filterDetails) {
          const filterValues = this.filterDetails[columns];
          if (Array.isArray(filterValues) && filterValues.length > 0) {
            this.searchDropdownItems[columnName].forEach((item) => {
              item.isSelected = filterValues.includes(item.name);
            });
          } else {
            this.searchDropdownItems[columnName].forEach((item) => {
              item.isSelected = false;
            });
          }
        }
      } catch (error) {
        console.error(`Error fetching locations for ${columnName}:`, error);
        this.searchDropdownItems[columnName] = [];
      } finally {
        this.searchLoading = false;
      }
    },

    selectLocation() {
      const columnMapping = {
        assets: "asset",
        fields: "field",
        wells: "well",
        reservoirs: "reservoir",
        fluidType: "fluidType",
        tests: "selectedTests",
        fluidSampleID: "fluidSampleID", // Added fluidSampleID mapping
      };

      if (this.filterDetails?.ID) {
        for (const [key, locations] of Object.entries(this.selectedLocations)) {
          const filterKey = columnMapping[key];
          if (filterKey && Array.isArray(this.filterDetails[filterKey])) {
            locations.forEach((location) => {
              if (!this.filterDetails[filterKey].includes(location)) {
                this.filterDetails[filterKey].push(location);
              }
            });
          }
        }
        const withFilter = true;
        this.$emit("getFilterFromTable", {
          ...this.filterDetails,
          withFilter,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
        });
      }

      else {

        this.$emit("getFilterFromTable", {
          ...this.selectedLocations,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
        });
      }
      this.loadItems();
    },
    resetTableFilter() {
      this.searchDropdownItems = {
        assets: [],
        fields: [],
        wells: [],
        reservoirs: [],
        fluidType: [],
        tests: [],
        fluidSampleID: []
      };
      this.selectedLocations = {
        assets: [],
        fields: [],
        wells: [],
        reservoirs: [],
        fluidTypes: [],
        tests: [],
        fluidSampleID: []
      };
      this.serverItems = [];
      this.totalItems = 0;
      this.$emit('update:pagination', { page: 1, itemsPerPage: Number(this.itemsPerPage) });
    },
    sort(sortColumn, order) {
      const columnMapping = {
        assets: "asset",
        fields: "field",
        wells: "well",
        reservoirs: "reservoir",
        fluidType: "fluidType",
        tests: "selectedTests",
        fluidSampleID: "fluidSampleID"
      };

      if (sortColumn.toLowerCase() === 'sample id') {
        sortColumn = 'fluidSampleID';
      } else {
        sortColumn = sortColumn.toLowerCase();
      }

      if (this.filterDetails) {
        for (const [key, locations] of Object.entries(this.selectedLocations)) {
          const filterKey = columnMapping[key];
          if (filterKey && Array.isArray(this.filterDetails[filterKey])) {
            locations.forEach((location) => {
              if (!this.filterDetails[filterKey].includes(location)) {
                this.filterDetails[filterKey].push(location);
              }
            });
          }
        }
        const withFilter = true;
        this.$emit("getFilterFromTable", {
          ...this.filterDetails,
          sortColumn, // Column to sort by
          sortDirection: order, // asc or desc
          withFilter,
          page: this.page,
          itemsPerPage: this.itemsPerPage,
        });
      }

      else {
        this.$emit("getFilterFromTable", {
          ...this.selectedLocations,
          sortColumn, // Column to sort by
          sortDirection: order, // asc or desc
          page: this.page,
          itemsPerPage: this.itemsPerPage,
        });
      }
      this.loadItems();
    },
    async downloadTableCSV() {
      this.loadingCsv = true;
        await this.fetchSamples();
      
      const headers = ['Sample ID', 'Asset', 'Field', 'Reservoir', 'Well', 'Fluid Type', 'Tests'];

      const rows = this.samplesCSV.map((item) => {
        const tests = [];

        if (item.compositiontests) tests.push(item.compositiontests.name || 'Composition');
        if (item.ccetests?.length) tests.push(item.ccetests[0].name || 'CCE Test');
        if (item.dltests?.length) tests.push(item.dltests[0].name || 'DL Test');
        if (item.cvdtests?.length) tests.push(item.cvdtests[0].name || 'CVD Test');
        if (item.separatortests?.length) tests.push(item.separatortests[0].name || 'Separator Test');
        if (item.viscositytests?.length) tests.push(item.viscositytests[0].name || 'Viscosity Test');

        return [
          item.fluidSampleID || '',
          item.location.asset || '',
          item.location.field || '',
          item.location.reservoir || '',
          item.location.well || '',
          item.fluidType || '',
          tests.join(', '), // Combine tests into a single string
        ];
      });

      const csvContent = [
        headers.join(','), // Convert headers to CSV format
        ...rows.map((row) => row.map((cell) => `"${cell}"`).join(',')), // Escape cells and join rows
      ].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Fluids_Characterization_Data.csv';
      link.click();
      URL.revokeObjectURL(link.href);
      this.loadingCsv = false;
    },
    async fetchSamples() {
      try {
        const params = {
          pageSize: this.totalItems,
          pageNumber: 1,
          viewSummary: true
        };
        if (this.filterDetails) {
          params.field = this.filterDetails.field?.length ? `["${this.filterDetails.field.join('","')}"]` : '[]';
          params.well = this.filterDetails.well?.length ? `["${this.filterDetails.well.join('","')}"]` : '[]';
          params.asset = this.filterDetails.asset?.length ? `["${this.filterDetails.asset.join('","')}"]` : '[]';
          params.reservoir = this.filterDetails.reservoir?.length ? `["${this.filterDetails.reservoir.join('","')}"]` : '[]';
          params.fluidType = this.filterDetails.fluidType?.length ? `["${this.filterDetails.fluidType.join('","')}"]` : '[]';
                    params.sampleType = this.filterDetails.sampleType?.length ? `["${this.filterDetails.sampleType.join('","')}"]` : '[]';
              params.fluidClassification = this.filterDetails.fluidClassification?.length ? `["${this.filterDetails.fluidClassification.join('","')}"]` : '[]';
          params.selectedTests = this.filterDetails.selectedTests?.length
            ? `["${this.filterDetails.selectedTests.map(test => test.toLowerCase().replace(/\s+/g, '')).join('","')}"]`
            : '[]';
          params.fluidSampleID = this.filterDetails.fluidSampleID?.length ? `["${this.filterDetails.fluidSampleID.join('","')}"]` : '[]';
        }
        const response = await api.get('public/api/samples', { params });
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          this.samplesCSV = response.data.data.samples; // Assuming the API response has this structure
        }
        else if (response && response.data && response.data.message) {
          console.error(response.data.message);
        }
        else {
          console.error("Error fetching samples");
        }
      } catch (error) {
        console.error('Error fetching samples:', error);
      }
    },
    goToPdf(sampleId, extension) {
      this.snackbarMessage = null;
      this.pdfLoader = true;
      api
        .get(process.env.VUE_APP_API_URL + `public/api/samples/${sampleId}/download`, {
          responseType: 'blob',
        })
        .then(async (response) => {
          const result = await blobFromSampleReportResponse(
            response,
            extension
          );
          this.pdfLoader = false;
          if (!result.ok) {
            this.snackbarMessage = result.message;
            return;
          }
          const url = URL.createObjectURL(result.blob);
          window.open(url, '_blank');
        })
        .catch(async (error) => {
          this.pdfLoader = false;
          const fallbackDownloadError = `Failed to download ${extension.toUpperCase()} report.`;
          const data = error.response?.data;
          if (data instanceof Blob) {
            try {
              const text = await data.text();
              const j = JSON.parse(text);
              if (j && Number(j.statusCode) >= 500) {
                this.snackbarMessage = fallbackDownloadError;
                return;
              }
              if (j && j.message) {
                this.snackbarMessage = j.message;
                return;
              }
            } catch (_) {
              /* fall through */
            }
          }
          if (error.response) {
            if (Number(error.response.status) >= 500) {
              this.snackbarMessage = fallbackDownloadError;
              return;
            }
            this.snackbarMessage = `The ${extension.toUpperCase()} report is not available for synthetic data in this study/sample/test. Please explore tests/samples under Asset: Public Data to check the power of this feature.`;
          }
        })
        .finally(() => {
          this.pdfLoader = false;
        });
    },
    async exportToPVTSim(sampleID, fluidSampleID) {
      try {
        const response = await api.post(`public/api/samples/export/${sampleID}`, {});
        
        if (response && response.data && (response.data.statusCode === 200 || response.data.statusCode === 201)) {
          const downloadUrl = response.data.data?.downloadUrl;
          const filename = response.data.data?.filename || `Calsep-file-${fluidSampleID}.xlsx`;
          
          if (!downloadUrl) {
            store.commit('api/showSnackbar', {
              message: 'Download URL not found in response',
              color: '#E53535',
              timeout: 5000
            });
            return;
          }
          
          try {
            const downloadResponse = await api.get(downloadUrl, {
              responseType: 'blob'
            });
            
            const blob = new Blob([downloadResponse.data], { 
              type: downloadResponse.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          } catch (downloadError) {
            console.warn('Axios download failed, using direct link:', downloadError);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = filename;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          
          store.commit('api/showSnackbar', {
            message: response.data.data?.message || 'Export successful',
            color: '#4CAF50',
            timeout: 3000
          });
        } else {
          const errorMessage = response.data?.message || response.data?.data?.message || 'Error exporting to PVTSim';
          store.commit('api/showSnackbar', {
            message: errorMessage,
            color: '#E53535',
            timeout: 5000
          });
        }
      } catch (error) {
        console.error('Error exporting to PVTSim:', error);
        let errorMessage = 'Error exporting to PVTSim. Please try again.';
        
        if (error.response) {
          if (error.response.data) {
            if (typeof error.response.data === 'object') {
              errorMessage = error.response.data.message || 
                           error.response.data.data?.message || 
                           error.response.data.error || 
                           errorMessage;
            } else if (error.response.data instanceof Blob) {
              try {
                const text = await new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsText(error.response.data);
                });
                const errorData = JSON.parse(text);
                errorMessage = errorData.message || errorData.data?.message || errorData.error || errorMessage;
              } catch (e) {
                void 0;
              }
            }
          }
          
          if (error.response.status) {
            errorMessage = `Error ${error.response.status}: ${errorMessage}`;
          }
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        store.commit('api/showSnackbar', {
          message: errorMessage,
          color: '#E53535',
          timeout: 5000
        });
      }
    },
    
    populateSelectedLocations(filterDetails) {
      const columnMapping = {
        asset: "assets",
        field: "fields", 
        well: "wells",
        reservoir: "reservoirs",
        fluidType: "fluidType",
        selectedTests: "tests",
        fluidSampleID: "fluidSampleID"
      };
      
      for (const [filterKey, locations] of Object.entries(filterDetails)) {
        const columnKey = columnMapping[filterKey];
        if (columnKey && Array.isArray(locations) && locations.length > 0) {
          this.selectedLocations[columnKey] = [...locations];
        }
      }
    }
  },
  watch: {
    filterDetails: {
      handler(newVal) {
        if (newVal) {
          this.populateSelectedLocations(newVal);
        }
      },
      immediate: true
    },
    filterData: {
      handler() {
        this.loadItems();
      },
      immediate: true,
      deep: true
    },
    isLoading: {
      handler(newVal) {
        this.loading = newVal;
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.exploration-table {
  /* height: calc(100vh - 425px); */
  /* overflow-y: auto; */
  position: relative;
}

.table-title {
  font-size: 23.50px;
  font-weight: bold;
  margin-bottom: 10px;
}

.applied-filters {
  font-size: 13.50px;
  font-weight: 600;
  line-height: 16px;
  color: #FFFFFF;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: "Inter", sans-serif !important;
}

.applied-filters>span {
  margin-right: 10px;
  border-right: 1px solid #FFFFFF;
  padding-right: 10px;
  font-size: 11.50px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
}

.applied-filters span:nth-child(5) {
  border-right: none !important;
}

.test-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-dropdown {
  background: white;
  width: 100%;
  border-radius: 4px;
  max-height: 200px;
}
</style>